//**auto-generated don't edit this code**//
import {ContractHttpClient, getClientConfig} from '@esgi/contracts';
import {Disposable} from '@esgi/core/service';
import {init} from './endpoints/init';
import {quickSetupSave} from './endpoints/quick-setup-save';
import {tabsTestSessionResultsSave} from './endpoints/tabs-test-session-results-save';
import {tabsTestResultVerbiageSave} from './endpoints/tabs-test-result-verbiage-save';
import {tabsStudentTestingOptionsSave} from './endpoints/tabs-student-testing-options-save';
import {tabsTestButtonLabelsSave} from './endpoints/tabs-test-button-labels-save';
import {tabsKeyboardShortcutsSave} from './endpoints/tabs-keyboard-shortcuts-save';
import {tabsSystemSettingsSave} from './endpoints/tabs-system-settings-save';

export class V2TeachersUserSettingsController implements Disposable {
	private httpClientConfig = getClientConfig('esgi-apigateway');
	private httpClient: ContractHttpClient = new ContractHttpClient(this.httpClientConfig);

	public init = init(this.httpClient);
	public quickSetupSave = quickSetupSave(this.httpClient);
	public tabsTestSessionResultsSave = tabsTestSessionResultsSave(this.httpClient);
	public tabsTestResultVerbiageSave = tabsTestResultVerbiageSave(this.httpClient);
	public tabsStudentTestingOptionsSave = tabsStudentTestingOptionsSave(this.httpClient);
	public tabsTestButtonLabelsSave = tabsTestButtonLabelsSave(this.httpClient);
	public tabsKeyboardShortcutsSave = tabsKeyboardShortcutsSave(this.httpClient);
	public tabsSystemSettingsSave = tabsSystemSettingsSave(this.httpClient);

	public dispose(): void {
		this.httpClient?.destroy();
	}
}
